var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback-container" },
    [
      _c("div", { staticClass: "feedback-title" }, [_vm._v("😊 期待您的反馈")]),
      _c(
        "div",
        { staticClass: "quick-tag" },
        _vm._l(_vm.feedbackQuickTag, function (item, index) {
          return _c(
            "yxt-tag",
            {
              key: index,
              staticClass: "tag-item",
              attrs: {
                type: "pick",
                "pick-type": "mark",
                picked: _vm.selectedTag.includes(item),
              },
              on: {
                click: function ($event) {
                  return _vm.selectQuickTag(item)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(item) + "\n    ")]
          )
        }),
        1
      ),
      _c("yxtf-input", {
        staticClass: "feedback-input",
        attrs: {
          type: "textarea",
          "show-word-limit": "",
          rows: 3,
          maxlength: 200,
          placeholder: "请输入反馈内容",
        },
        model: {
          value: _vm.feedbackContent,
          callback: function ($$v) {
            _vm.feedbackContent = $$v
          },
          expression: "feedbackContent",
        },
      }),
      _c(
        "div",
        { staticClass: "option" },
        [
          _c(
            "yxtf-button",
            {
              attrs: { round: "", size: "medium" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "yxtf-button",
            {
              attrs: {
                type: "primary",
                size: "medium",
                round: "",
                disabled: !_vm.feedbackContent.trim(),
                loading: _vm.loading,
              },
              on: { click: _vm.onSubmit },
            },
            [_vm._v("提 交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }